var exports = {
  "VH": "ForwardMessagePreview.module__preview___VnQ3YU",
  "Qs": "ForwardMessagePreview.module__content___VnQ3YU",
  "iU": "ForwardMessagePreview.module__message___VnQ3YU",
  "Mg": "ForwardMessagePreview.module__messageWithAttachments___VnQ3YU",
  "oh": "ForwardMessagePreview.module__edited___VnQ3YU",
  "kp": "ForwardMessagePreview.module__attachmentRow___VnQ3YU",
  "$r": "ForwardMessagePreview.module__attachmentIcon___VnQ3YU",
  "eI": "ForwardMessagePreview.module__attachmentSummary___VnQ3YU",
  "rs": "ForwardMessagePreview.module__attachmentSummaryWithText___VnQ3YU",
  "vH": "ForwardMessagePreview.module__thumbnailStack___VnQ3YU",
  "xn": "ForwardMessagePreview.module__thumbnail___VnQ3YU",
  "q_": "ForwardMessagePreview.module__thumbnailImage___VnQ3YU",
  "SK": "ForwardMessagePreview.module__thumbnailPlaceholder___VnQ3YU",
  "XX": "ForwardMessagePreview.module__thumbnailPlaceholderIcon___VnQ3YU",
  "Uy": "ForwardMessagePreview.module__thumbnailVideo___VnQ3YU",
  "tk": "ForwardMessagePreview.module__thumbnailSensitive___VnQ3YU",
  "$3": "ForwardMessagePreview.module__thumbnailWithOverflow___VnQ3YU",
  "uZ": "ForwardMessagePreview.module__playIcon___VnQ3YU",
  "mB": "ForwardMessagePreview.module__overflowCount___VnQ3YU",
};

module.exports = exports;
